import React from "react";
import { useSelector } from "react-redux";
import CustomTable from "../../../blueplanitUtils/CustomTabels";
import { EmergencyContactModelPopUp } from "../../../components/ProfileEditpopUp/EmergencyContactModelPopUp";

const EmergencyContacts = () => {
  const Contacts = useSelector((state) => state.employee.emergencyContacts);
  const contactColumns = ["Name", "Relationship", "Phone"];
  const contactLabels = ["name", "relationship", "phoneNumber"];
  return (
    <>
      <CustomTable
        title="Emergency Contacts"
        data={Contacts}
        columns={contactColumns}
        dataLabel={contactLabels}
        Id="emergency_contact_modal"
      />
      <EmergencyContactModelPopUp />
    </>
  );
};

export default EmergencyContacts; 